import { inject, Injectable } from "@angular/core";
import {  ProcessContentService } from "@alfresco/adf-core";
import { from, interval, Observable, of, Subject, timer } from "rxjs";
import { catchError, defaultIfEmpty, delay, endWith, filter, flatMap, map, retry, switchMap, take, takeUntil, tap, timeout } from "rxjs/operators";
import { RelatedContentRepresentation } from "@alfresco/js-api";


@Injectable()
export class ApsDocumentLinkElementPreviewService {

  private trigger$: Observable<number> = timer(0, 1500);
  private readonly processContentService = inject(ProcessContentService);

  public getRenditionBlobUrl(content: RelatedContentRepresentation, renditionType: 'preview' | 'thumbnail' = 'thumbnail', retries = 10): Observable<string> {
     return this.trigger$.pipe(
      switchMap(() => this.processContentService.getFileContent(content.id)),
      filter((content:RelatedContentRepresentation) => !this.isRenditionQueued(content, renditionType)),
      take(1),
      switchMap((content:RelatedContentRepresentation) => {
        if (this.isRenditionReady(content, renditionType)) {
          return from(this.processContentService.contentApi.getRawContent(content.id, renditionType)).pipe(
            map((blob: Blob) => URL.createObjectURL(blob))
          );
        }
        return of(null);
      }),
      defaultIfEmpty(null)
    )
  }

  private isRenditionReady(content: RelatedContentRepresentation, renditionType: 'preview' | 'thumbnail' = 'thumbnail'): boolean {
    return content[renditionType + "Status"] == "created"
  }

  private isRenditionError(content: RelatedContentRepresentation, renditionType: 'preview' | 'thumbnail' = 'thumbnail'): boolean {
    return content[renditionType + "Status"] == "error"
  }

  private isRenditionQueued(content: RelatedContentRepresentation, renditionType: 'preview' | 'thumbnail' = 'thumbnail'): boolean {
    return content[renditionType + "Status"] == "queued"
  }
}
